import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SignalrEvent } from '@wdx/shared/utils';
import { of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { EngagementState } from '../../models/engagement-state.model';
import { EngagementTrigger } from '../../models/engagement-trigger.model';
import { EngagementVisitor } from '../../models/engagement-visitor.model';
import { newSystemSignalrEvent } from '../system-events/system-events.actions';
import * as engagementBarActions from './../engagement-bar/engagement-bar.actions';
import * as engagementsActions from './engagements.actions';

@Injectable()
export class EngagementsEffects {
    private actions$ = inject(Actions);

    listenToEvents$ = createEffect(() =>
        this.actions$.pipe(
            ofType(newSystemSignalrEvent),
            filter(
                ({ event }) =>
                    event.signalrEvent === SignalrEvent.VisitorEngaged,
            ),
            map(({ event }): EngagementVisitor => event.data),
            switchMap((visitor) =>
                of(
                    engagementBarActions.setParty({
                        party: visitor.matches[0],
                    }),
                    engagementBarActions.setActivityId({
                        activityId: visitor.activityId,
                    }),
                    engagementBarActions.setEngagementState({
                        engagementState: {
                            [EngagementTrigger.Start]: EngagementState.Started,
                            [EngagementTrigger.End]: EngagementState.Ended,
                        }[visitor.trigger],
                    }),
                    engagementBarActions.setVisibility({
                        isVisible: true,
                    }),
                    engagementsActions.visitorEngagedSuccess({ visitor }),
                ),
            ),
        ),
    );
}
